import { render } from "./timeline.vue?vue&type=template&id=d2379e52"
import script from "./timeline.js?vue&type=script&lang=js"
export * from "./timeline.js?vue&type=script&lang=js"

import "./timeline.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__